import { PageType, SingularPage } from "../../types";

export const pages: SingularPage[] = [
  {
    type: PageType.notes,
    title: "Særlige bemærkninger",
  },
  {
    type: PageType.science,
    title: "Videnskabelig publicering",
  },
  {
    type: PageType.method,
    title: "Undersøgelsens metode",
  },
  {
    type: PageType.evidence,
    title: "Samlet evidens",
  },
];
